// stores/accordionStore.ts
import { create } from "zustand";

interface AccordionState {
  sectionsMap: Record<string, boolean>;

  // Registra una nuova sezione se non esiste
  registerSection: (sectionKey: string, defaultExpanded?: boolean) => void;

  // Metodi per gestire lo stato
  setExpanded: (sectionKey: string, isExpanded: boolean) => void;

  // Metodo per estrarre la sezione dal field path
  getSectionFromFieldPath: (fieldPath: string) => string | null;

  // Metodo per aprire l'accordion di un campo in errore
  expandSectionForField: (fieldPath: string) => void;

  // Reset allo stato iniziale
  resetSections: () => void;

  // Rimuove una sezione
  unregisterSection: (sectionKey: string) => void;
}

export const useAccordionStore = create<AccordionState>((set, get) => ({
  sectionsMap: {},

  registerSection: (sectionKey, defaultExpanded = false) =>
    set((state) => {
      // Registra solo se non esiste già
      if (!(sectionKey in state.sectionsMap)) {
        return {
          sectionsMap: {
            ...state.sectionsMap,
            [sectionKey]: defaultExpanded,
          },
        };
      }
      return state;
    }),

  setExpanded: (sectionKey, isExpanded) =>
    set((state) => ({
      sectionsMap: {
        ...state.sectionsMap,
        [sectionKey]: isExpanded,
      },
    })),

  getSectionFromFieldPath: (fieldPath) => {
    let cleanPath = fieldPath.replace(/\[(\d+)\]/g, "");

    cleanPath = cleanPath.replace(/^vehicles\./i, "");

    const firstSegment = cleanPath.split(".")[1];

    // Verifica se esiste nello store
    const { sectionsMap } = get();
    if (firstSegment in sectionsMap) {
      return firstSegment;
    }

    return null;
  },

  expandSectionForField: (fieldPath) => {
    const section = get().getSectionFromFieldPath(fieldPath);
    if (section) {
      get().setExpanded(section, true);
    }
  },

  resetSections: () =>
    set({
      sectionsMap: {},
    }),

  unregisterSection: (sectionKey) =>
    set((state) => {
      const { [sectionKey]: removed, ...rest } = state.sectionsMap;
      return { sectionsMap: rest };
    }),
}));
